// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-animationstyleAnimation-shakeHorizontal-enrcc{animation:assets-scss-animationstyleAnimation-shake-horizontal-bxnfo .4s cubic-bezier(.455,.03,.515,.955) both}@keyframes assets-scss-animationstyleAnimation-shake-horizontal-bxnfo{0%,to{transform:translateX(0)}10%,30%,50%,70%{transform:translateX(-10px)}20%,40%,60%{transform:translateX(10px)}80%{transform:translateX(8px)}90%{transform:translateX(-8px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shakeHorizontal": "assets-scss-animationstyleAnimation-shakeHorizontal-enrcc",
	"shake-horizontal": "assets-scss-animationstyleAnimation-shake-horizontal-bxnfo"
};
module.exports = ___CSS_LOADER_EXPORT___;
